import { useEffect, useState } from 'react';
import { fontsService, type FontFamily } from '@/services/fontsService';
import { useDebounce } from '../useDebounce';

const SEARCH_DEBOUNCE_MS = 400;

export const useFonts = (search: string) => {
  const debouncedSearch = useDebounce(search, SEARCH_DEBOUNCE_MS);
  const [fonts, setFonts] = useState<FontFamily[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    fontsService
      .getFonts({ search: debouncedSearch })
      .then((result) => {
        if (!cancelled) setFonts(result);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setFonts([]);
        setError(err instanceof Error ? err.message : 'Error al obtener las fuentes');
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [debouncedSearch]);

  return { fonts, isLoading, error };
};
